import { isUuid } from '@/shared/clinical/detailPage'
import { isExternalModuleCode } from '@/shared/routing/patientOrigin'

export interface PatientRegistrationSearch {
  externalModule?: string
  externalCandidateId?: string
}

/** An external-module continuation is useful only as a complete, bounded pair. */
export function validatePatientRegistrationSearch(
  search: Record<string, unknown>,
): PatientRegistrationSearch {
  const externalModule = search['externalModule']
  const externalCandidateId = search['externalCandidateId']
  return isExternalModuleCode(externalModule) &&
    typeof externalCandidateId === 'string' &&
    isUuid(externalCandidateId)
    ? { externalModule, externalCandidateId }
    : {}
}
